import React from "react"

import * as styles from "./styles/footer.module.css"

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <span className="c-secondary">
        No trackers or analytics are used.
      </span>
      <span className="c-secondary">
        <a href="https://instagram.com/joshuasoehn">Instagram</a>,&nbsp;
        <a href="https://www.linkedin.com/in/joshuasoehn/">LinkedIn</a>,&nbsp;
        <a href="https://www.are.na/joshua-sohn/channels">Are.na</a>,&nbsp;
        <a href="mailto:hello@joshuasoehn.com">E-Mail</a>
      </span>
    </footer>
  )
}

export default Footer
